module.exports = __webpack_public_path__ + "img/tool_4.09decb87.png";